<script>
import Picker from '../picker';
import DatePanel from '../panel/date';
import DateRangePanel from '../panel/date-range';
import MonthRangePanel from '../panel/month-range';

const getPanel = function (type) {
  if (type === 'daterange' || type === 'datetimerange') {
    return DateRangePanel;
  } else if (type === 'monthrange') {
    return MonthRangePanel;
  }
  return DatePanel;
};

export default {
  name: 'ElDatePicker',
  mixins: [Picker],

  props: {
    type: {
      type: String,
      default: 'date'
    },
    timeArrowControl: Boolean,
    footerAlign: {
      type: String,
      default: 'center'
    },
    // 分钟 / 秒跨度
    stepper: [Number, Boolean],
    // 点击 <此刻> 不关闭 picker
    clickNowShowPicker: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    type (type) {
      if (this.picker) {
        this.unmountPicker();
        this.panel = getPanel(type);
        this.mountPicker();
      } else {
        this.panel = getPanel(type);
      }
    }
  },

  created () {
    this.panel = getPanel(this.type);
  }
};
</script>



// WEBPACK FOOTER //
// elDatePicker.vue?142752b5